import { render, staticRenderFns } from "./MailListWebpart.vue?vue&type=template&id=28ed426c&scoped=true"
import script from "./MailListWebpart.ts?vue&type=script&lang=ts&external"
export * from "./MailListWebpart.ts?vue&type=script&lang=ts&external"
import style0 from "./MailListWebpart.vue?vue&type=style&index=0&id=28ed426c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed426c",
  null
  
)

export default component.exports